import type { PageExperience } from '@/features/experiences/types';
import { Box } from '@/ui';
import { FONT_TEXT } from '../../../css/customFonts';
import { getStyleById } from '../../../theme';

type Props = {
  dayOfWeek: number;
  experience: PageExperience;
};

const DAY_LABELS: Record<number, string> = {
  1: 'Sun',
  2: 'Mon',
  3: 'Tue',
  4: 'Wed',
  5: 'Thu',
  6: 'Fri',
  7: 'Sat',
};

export const DayHeader = ({ dayOfWeek, experience }: Props) => {
  const theme = getStyleById(experience.styleId ?? undefined);

  return (
    <Box
      color={theme.neutral3}
      fontFamily={FONT_TEXT}
      fontSize="0.8em"
      fontWeight="500"
      p="0.3em 0"
      textAlign="center"
      textTransform="uppercase"
    >
      {DAY_LABELS[dayOfWeek]}
    </Box>
  );
};
